<template>
	<div
		v-if="showWarning"
		class="highlight-iq-warning"
	>
		<div class="highlight-iq-warning__icon">
			<Icon
				icon-name="info"
				size="md"
			/>
		</div>
		<div class="highlight-iq-warning__text">
			{{ warningText }}
		</div>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'HighlightIqWarning',
	components: {
		Icon,
	},
	props: {
		warningType: {
			type:      String,
			default:   '',
			validator: value => ['', 'not-enough-tags', 'not-enough-team-tags', 'no-results'].includes(value),
		},
	},
	computed: {
		showWarning() {
			return !!this.warningType;
		},
		warningText() {
			switch (this.warningType) {
			case 'not-enough-tags':
				return this.$I18n.trans('highlights.highlight_tool.warnings.not_enough_tags');
			case 'not-enough-team-tags':
				return this.$I18n.trans('highlights.highlight_tool.warnings.not_enough_team_tags');
			case 'no-results':
				return this.$I18n.trans('highlights.highlight_tool.warnings.no_results');
			default:
				return '';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.highlight-iq-warning {
	display: flex;
	align-items: center;
	padding: $sp2;
	background-color: var(--color-yellow-warning-bg);
	border-radius: $border-radius--sm;
	margin-top: $sp2;
}

.highlight-iq-warning__icon {
	margin-right: $sp2;
	color: var(--color-yellow-warning);
	flex-shrink: 0;
}

.highlight-iq-warning__text {
	color: var(--color-yellow-warning);
	@include font-size(fs-80);
}
</style>
